export default __webpack_public_path__ + "static/media/cs_icon_06_on.f5acc232.png";